import React from "react";
import { PropTypes } from "prop-types";
import { getLatestDeployedModel } from "./ModelButtons";

export default class ModelStatus extends React.Component {
  constructor(props) {
    super(props);
  }

  // parse model id from url search string
  // model_id = queryString.parse(this.props.location.search).model

  render() {
    let trainStatus = null;
    let deployStatus = null;
    if (this.props.model) {
      const [latestModelVersion] = this.props.model.versions;
      if (latestModelVersion?.status_fk === "training") {
        trainStatus = latestModelVersion.status_message;
      } else if (latestModelVersion?.status_fk === "not_trained") {
        trainStatus = latestModelVersion.status_message;
      }
      let trained_models = this.props.model.versions.filter(
        (v) => v.status_fk === "trained" || v.status_fk === "deployed",
      );
      if (trained_models.length > 0) {
        let latestDeployedModelVersion = getLatestDeployedModel(trained_models);
        deployStatus = latestDeployedModelVersion?.status_message;
      }
    }
    return (
      <>
        <div className="model-status">
          {trainStatus}
          {deployStatus}
        </div>
      </>
    );
  }
}

ModelStatus.propTypes = {
  model: PropTypes.shape({
    versions: PropTypes.arrayOf(
      PropTypes.shape({
        status_fk: PropTypes.string,
        status_message: PropTypes.string,
      }),
    ),
  }),
};
